import React, { type ReactNode } from 'react';
import { styled } from '@compiled/react';
import Spinner from '@atlaskit/spinner';
import Placeholder from '@atlassian/jira-placeholder';
import { useRelayResource } from '@atlassian/jira-relay-utils/src/services/resources/index.tsx';
import { deploymentPreconditionRelayResource } from '@atlassian/jira-router-resources-software-deployments/src/services/index.tsx';
import { PreconditionCheck as PreconditionCheckEntryPoint } from '@atlassian/jira-software-deployments-precondition/src/ui/index.tsx';

export const Loading = () => (
	<LoadingWrapper>
		<Spinner size="large" />
	</LoadingWrapper>
);

export const PreconditionCheck = ({ children }: { children: ReactNode }) => {
	const { queryReference } = useRelayResource(deploymentPreconditionRelayResource);

	return (
		<Placeholder name="precondition-check-entry-point" fallback={<Loading />}>
			{queryReference != null ? (
				<PreconditionCheckEntryPoint queryReference={queryReference}>
					{children}
				</PreconditionCheckEntryPoint>
			) : null}
		</Placeholder>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const LoadingWrapper = styled.div({
	width: '100%',
	height: '100%',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
});
